import CardActivationScreen from 'features/cardManagement/screens/cardActivation/CardActivationScreen/CardActivationScreen';

export default function CardActivationPage() {
  return <CardActivationScreen />;
}
